module.exports = __webpack_public_path__ + "static/img/Tim-Taranto.6cd5181.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tim-Taranto.jpg
// module id = uyvk
// module chunks = 0